import { get } from 'lodash'

export const selectDiscountsIncompatibilities = state =>
  get(state, 'discountsIncompatibilities.discountsIncompatibilities')
export const selectDiscountsIncompatibilitiesMatrix = state =>
  get(state, 'discountsIncompatibilities.matrix')
export const selectLoading = state => get(state, 'discountsIncompatibilities.loading')
export const selectError = state => get(state, 'discountsIncompatibilities.error')
